import React, { createContext, useContext } from "react";

const VoiceGuidedFormContext = createContext(null);

export function VoiceGuidedFormProvider({ value, children }) {
  return (
    <VoiceGuidedFormContext.Provider value={value}>
      {children}
    </VoiceGuidedFormContext.Provider>
  );
}

export function useVoiceGuidedForm() {
  return useContext(VoiceGuidedFormContext);
}

export function useVoiceFieldActive(voiceFieldId) {
  const context = useVoiceGuidedForm();
  if (!context?.activeFieldId || !voiceFieldId) {
    return false;
  }

  return context.activeFieldId === voiceFieldId;
}

/**
 * Wire normal form controls into the guided workflow event surface.
 */
export function useGuidedFieldHandlers(fieldId, setValue) {
  const guidedForm = useVoiceGuidedForm();

  return {
    onChange: (value) => {
      setValue(value);
      guidedForm?.notifyFieldChange?.(fieldId, value);
    },
    onBlur: () => {
      guidedForm?.notifyFieldBlur?.(fieldId);
    },
  };
}
